import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { CaptchaDbModel } from '@models/captcha.model';
import { map, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  private http = inject(HttpClient);

  generateCaptcha(): Observable<CaptchaDbModel> {
    const body = { store_id: 2, start: '2024-02-01 08:00:00', end: '2024-02-01 08:15:00' };
    return this.http.post<CaptchaDbModel>(`${environment.restAPI}captcha/generate`, body);
  }

  validateCaptcha(uuid: string, solution: string): Observable<boolean> {
    const body = { uuid, solution };
    return this.http.post<{ success: boolean }>(`${environment.restAPI}captcha/validate`, body).pipe(
      map(result => typeof result?.success === 'boolean' ? result.success : false)
    );
  }
}
